import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'lib/paypalphrodite'
import content from 'pp-react-l10n'
import DocumentTitle from 'react-document-title'
import { Link } from 'react-router-dom'
import { connect } from 'transfer/utils/p2p-connect'
import LINKS from '../../../../config/links.json'
import Events from '../../lib/analytics/eventTags'
import { tracking } from '../../lib/analytics/mParticle'
import { DC_SEND_MONEY } from '../constants'
import styles from './dcSendMoneyRequestSuccess.styles'

let i18n = content('transfer/send/success')

export const DCSendMoneyRequestSuccess = props => {
  const requestMoreUrl = props.requestMoreStartsOver
    ? props.rootURL
    : `${props.rootURL}/send`
  return (
    <DocumentTitle title={i18n('a11y.title.approvalSubmission.success')}>
      <div className={`section ${css(styles.container)}`}>
        <div className={css(styles.wrapper)}>
          <div className={css(styles.iconHolder)}>
            <div className={css(styles.icon)}>
              <img
                alt=""
                id="success-checkmark-outline"
                data-nemo="success-checkmark"
                src={DC_SEND_MONEY.SUCCESS}
                style={styles.img}
              />
            </div>
          </div>
          <div className={css(styles.header)}>
            <h2 className={css(styles.headerText)}>
              {i18n('success.approvalRequestHeader')}
            </h2>
          </div>
          <div className={css(styles.subHeader)}>
            <p className={css(styles.subHeaderText)}>
              {i18n.html('success.approvalRequestBody', {
                redirectUrl: LINKS.ALL.DUAL_CONTROL_URL,
              })}
            </p>
          </div>
          <div className={css(styles.btnHolder)}>
            <Link
              to={requestMoreUrl}
              className={`vx_btn done ${css(styles.doneBtn)}`}
              data-pagename={`main:p2p:approval:request::done`}
              data-pagename2={`main:p2p:approval:request::done:node::`}
              data-nextpagegroup="main:p2p:approval:request::start"
              data-nextpagename="main:p2p:approval:request:start:node::"
              onClick={() => tracking(Events.p2p_success_done_pressed({}))}
            >
              {i18n('success.doneButton')}
            </Link>
          </div>
        </div>
      </div>
    </DocumentTitle>
  )
}

const mapStateToProps = ({ server }) => ({
  rootURL: server.rootURL,
  requestMoreStartsOver: server.env === 'xb',
})
export default connect(mapStateToProps)(DCSendMoneyRequestSuccess)

DCSendMoneyRequestSuccess.propTypes = {
  rootURL: PropTypes.string.isRequired,
  requestMoreStartsOver: PropTypes.bool.isRequired,
}
